<template>
    <div>
      <h3 class='text-bold' style="margin-bottom: 15px">{{$t('pages.profile.prompt')}}</h3>
      <div class='k6-box'>
        <form class="slika" enctype="multipart/form-data" novalidate>
          <div class='k6-profile-image'>
            <img :src='profile.profilePhoto' alt="Profile image" />
            <input id="image-upload" type="file" name="file" style="display: none" @change="filesChange($event.target.name, $event.target.files); fileCount = $event.target.files.length" accept="image/*">
            <button v-if="!uid" class="btn btn-success k6-btn" @click.prevent="onClickPhotoUpload" style="width: 130px;">
              {{$t("pages.profile.userpicture.change")}}
            </button>
            <!-- <button v-if="!uid" class="btn btn-success k6-btn" style="width: 130px; color: #B1B1B1; border: 0.9px solid #EDF0F5; background-color: transparent;">
              {{$t("pages.profile.userpicture.delete")}}
            </button> -->
          </div>
        </form>
        
        <!-- personal info -->
        <div class='k6-profile-data'>
          <div class="segment">
            <h3 class="text-bold k6-form-segment-title">{{$t("pages.profile.userData")}}</h3>
            <form class="form-horizontal">

              <!-- Uporabniško ime -->
              <div class="k6-form-row">
                <label for="username">{{$t('pages.profile.username')}}:</label>
                <input type="text" class="form-control" :value="profile.username" id="username" disabled/>
              </div>

              <!-- Ime -->
              <div class="k6-form-row">
                <label for="firstName">{{$t('pages.profile.name')}}:</label>
                <input type="text" class="form-control" v-model="profile.firstName" id="firstName"/>
              </div>

              <!-- Priimek -->
              <div class="k6-form-row">
                <label for="lastName">{{$t('pages.profile.surname')}}:</label>
                <input type="text" class="form-control" v-model="profile.lastName" id="lastName"/>
              </div>

              <!-- email -->
              <div class="k6-form-row">
                <label for="oldPassword">{{$t('pages.profile.email')}}:</label>
                <input type="email" class="form-control" v-model="profile.email" id="email" disabled/>
              </div>

              <!-- Vpisna stevilka-->
              <div class="k6-form-row">
                <label for="studentId">{{$t('pages.profile.studentId')}}</label>
                <input type="text" class="form-control" v-model="profile.studentId" id="studentId"/>
              </div>
              
              <div class="k6-form-row" v-if="!uid && this.rolesSelected.length == 0">
                <label></label>
                <div style="display: flex; justify-content: flex-start; align-items: flex-start;">
                  <input type="checkbox" style="transform: scale(1.3); margin-top: 3px" v-model="admit" :disabled="uid">
                  <span style="margin-left: 10px;">{{$t("pages.profile.adminAdmit")}}</span>
                </div>
              </div>

              <div class="k6-form-row">
                <label></label>
                <button class="btn btn-success k6-btn" @click.prevent="updateProfile" style="width: fit-content">{{$t("pages.profile.save")}}</button>
              </div>

            </form>
          </div>

          <!-- change password (only for your profile) -->
          <div class="segment" v-if="!uid">
            <h3 class="text-bold k6-form-segment-title">{{$t("pages.profile.changepassword.userPassword")}}</h3>
            <form>
              <div class="k6-form-row">
                <label for="oldPassword">{{$t("pages.profile.changepassword.oldPass")}}:</label>
                <input type="password" class="form-control" v-model="oldPassword" id="oldPassword"/>
              </div>

              <div class="k6-form-row">
                <label for="oldPassword">{{$t("pages.profile.changepassword.newPass")}}:</label>
                <input type="password" class="form-control" v-model="newPassword" id="newPassword"/>
              </div>

              <div class="k6-form-row">
                <label for="oldPassword">{{$t("pages.profile.changepassword.repeatNewPass")}}:</label>
                <input type="password" class="form-control" v-model="repeatNewPassword" id="repeatNewPassword"/>
              </div>

              <div class="k6-form-row">
                <label></label>
                <button class="btn btn-success k6-btn" @click.prevent="changePassword" style="width: fit-content">{{$t("pages.profile.changepassword.change")}}</button>
              </div>
            </form>
          </div>

          <!-- change roles - only for Admin.user -->
          <div class="segment" v-if="uid">
            <h3 class="text-bold k6-form-segment-title">{{$t("pages.profile.changeroles.changeRole")}}</h3>
            <form role="form">
              <div v-for="role in roleList">
                <div class="k6-form-row">
                  <label></label>
                  <div>
                    <input type="checkbox" style="transform: scale(1.3); margin-top: 3px" :value="role.id" v-model="rolesSelected">
                    <span style="margin-left: 10px">{{role.displayName}}</span>
                  </div>
                </div>
              </div>

              <div class="k6-form-row">
                <label></label>
                <button type="submit" class="btn btn-success k6-btn" @click.prevent="updateRoles" style="width: fit-content">
                  {{$t("pages.profile.changeroles.changeRoleButton")}}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import Rest from './../../services/rest'
import { mapGetters } from 'vuex'
export default {
  data () {
    return {
      profile: {id: '', username: '', email: '', firstName: '', lastName: '', studentId: '', language: '', allowUseOfMyResults: '', role: '', profilePhoto: ''},
      roleList: [],
      roleCreatedMsg: '',
      rolesSelected: [],
      uid: this.$route.params.uid,
      userId: this.$route.params.uid,
      fileCount: 0,
      oldPassword: '',
      newPassword: '',
      repeatNewPassword: '',
      admit: false,
      lang: {id: null}
    }
  },
  mounted: function () {
    this.prepareComponent()
  },
  computed: {
    ...mapGetters({
      pictureBaseURL: 'pictureBaseURL',
      avatarUrl: 'getLinkToAvatar'
    })
  },
  methods: {
    prepareComponent () {
      this.getData()
    },
    updateRoles () {
      var postdata = {
        id: this.userId,
        roleIds: this.rolesSelected
      }
      Rest.request('PUT', '/users/' + this.userId, postdata).then((data) => {
        this.$snotify.success(this.$t('pages.buttons.success'), '')
      }).catch((_) => {
        this.$snotify.error(this.$t('pages.buttons.fail'), '')
      })
    },
    getData () {
      console.log(this)
      if (!this.uid) {
        this.userId = 'me'
      } else {
        this.getRoles()
      }
      return Rest.request('GET', '/users/' + this.userId).then(data => {
        const { id, username, email, firstName, lastName, studentId, language, allowUseOfMyResults } = data
        this.profile = {
          ...this.profile, id, username, email, firstName, lastName, studentId, language, allowUseOfMyResults
        }

        if (data.roles.length > 0) {
          this.profile.role = data['roles'][0].displayName
        } else {
          // if no role -> student
          this.profile.role = this.$t('pages.profile.student')
        }

        if (data.profilePictureUrl === null) {
          this.profile.profilePhoto = this.avatarUrl
        } else {
          this.profile.profilePhoto = this.pictureBaseURL + data.profilePictureUrl
        }

        this.rolesSelected = data.roles.map(function (a) {
          return a.id
        })
        this.admit = data['allowUseOfMyResults']
        this.lang.id = data['lngId']
      })
    },
    getRoles: function () {
      return Rest.request('GET', '/roles').then((data) => {
        this.roleList = data
      }).catch(function (err) {
        console.log(err)
      })
    },
    updateProfile () {
      const postdata = {
        ...this.profile,
        id: this.userId,
        lngId: this.lang.id,
        allowUseOfMyResults: this.admit
      }
      return Rest.request('PUT', '/users/' + this.userId, postdata).then((_) => {
        this.$snotify.success(this.$t('pages.buttons.updated'), '')
      })
    },
    onClickPhotoUpload () {
      const uploadElemenet = document.querySelector('#image-upload')
      uploadElemenet.click()
    },
    saveProfilePhoto (formData) {
      this.uploadProfilePhoto(formData)
      .then(_ => this.$snotify.success(this.$t('pages.profile.userpicture.success'), ''))
      .catch(_ => this.$snotify.error(this.$t('pages.profile.userpicture.errorMsg'), ''))
    },
    filesChange (fieldName, fileList) {
      if (!fileList.length) return
      this.saveProfilePhoto()
    },
    uploadProfilePhoto () {
      var form = window.jQuery('.slika')[0] // You need to use standard javascript object here
      var formData = new FormData(form)
      return Rest.requestForm('POST', '/upload/profilePicture', formData).then((data) => {
        this.$store.commit('updateProfilePicture', data.path)
        this.profile.profilePhoto = this.pictureBaseURL + data.path
      })
    },
    changePassword: function () {
      if (this.newPassword !== this.repeatNewPassword) {
        this.$snotify.error(this.$t('pages.profile.changepassword.noMatch'), '')
        return
      }
      var postdata = {
        oldPassword: this.oldPassword,
        newPassword: this.newPassword
      }
      Rest.request('POST', '/users/changePassword', postdata).then((_) => {
        this.$snotify.success(this.$t('pages.profile.changepassword.success'), '')
      })
    }
  },
  watch: {
    '$route' (to, from) {
      this.prepareComponent() // react to route changes... due to same component
    }
  }
}
</script>

<style scoped>
* {
  padding: 0;
  margin: 0;
}

label {
  font-weight: normal;
}

.k6-box {
  padding: 30px;
  display: flex;
  justify-content: space-between;
  border-radius: 6px;
  background-color: #fff;
  gap: 20px;
}

.k6-box.tabs {
    margin-top: 10px;
    margin-bottom: 10px;
    width: fit-content;
    gap: 20px;
    padding: 0px;
    border-radius: 0px;
}

.k6-profile-image {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
  width: 150px;
}

.k6-profile-image img {
  width: 109px;
  height: 109px;
  margin-top: 20px;
  margin-bottom: 10px;
  border-radius: 100%;
  mix-blend-mode: normal;
  /*box-shadow: 3px 3px 10px rgba(0, 0, 0, 0.2);*/
}

.k6-profile-data {
  flex: 1;
  display: flex;
  justify-content: flex;
  flex-direction: column;
  padding: 10px;
}

.segment {
  display: flex;
  flex-direction: column;
  margin-bottom: 10px;
}

.k6-form-segment-title {
  width: 200px;
  text-align: right;
  display: block;
  margin-bottom: 10px;
}

.k6-form-row {
  display: grid;
  grid-template-columns: 200px 1fr;
  gap: 20px;
  margin-bottom: 10px;
}

.k6-form-row > * {
  align-self: center;
}

.k6-form-row label {
  text-align: right;
  display: block;
}

input[type="checkbox"] {
  accent-color: #4AA362;
}

.k6-btn {
  border-radius: 8px;
  background-color: #4AA362;
  border: 0;
  padding: 6px 12px !important;
}

.k6-form-row input {
  border: 0.9px solid #dadce1;
  border-radius: 5px;
  max-width: 410px;
  padding: 6px 12px !important;
}

@media only screen and (max-width: 767px) {
  .k6-box {
    flex-direction: column;
  }

  .k6-profile-image {
    width: 100%;
    margin-bottom: 20px;
  }

  .k6-profile-image img {
    margin-top: 0px;
  }

  .k6-form-row {
    grid-template-columns: 1fr;
    gap: 5px;
  }

  .k6-form-row label {
    text-align: left;
  }

  .k6-form-row input {
    max-width: 100%;
  }

  .k6-form-segment-title {
    text-align: left;
    margin-bottom: 10px;
  }
}
</style>


// WEBPACK FOOTER //
// ProfileEdit.vue?71461bc6